import AccountPasskeys from 'components/RichProfile/MyAccount/AccountInfo/AccountPasskeys/AccountPasskeys';
import { withPasskeysProps } from 'viewModel/richProfile/myAccount/passkeys/withPasskeysProps';

export default withPasskeysProps(AccountPasskeys);
